module.exports = __webpack_public_path__ + "static/media/error.c42abde5.wav";